var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.24904V10.749C13.9996 10.8202 13.984 10.8905 13.9543 10.9552C13.9245 11.0198 13.8813 11.0774 13.8275 11.124C12.8725 11.9509 11.9594 12.249 11.0887 12.249C9.90687 12.249 8.80312 11.7028 7.77625 11.1959C6.11687 10.374 4.67438 9.66216 3 10.9847V13.749C3 13.8816 2.94732 14.0088 2.85355 14.1026C2.75979 14.1964 2.63261 14.249 2.5 14.249C2.36739 14.249 2.24021 14.1964 2.14645 14.1026C2.05268 14.0088 2 13.8816 2 13.749V3.24904C2.00048 3.17781 2.01617 3.1075 2.04603 3.04282C2.07589 2.97815 2.11922 2.9206 2.17313 2.87404C4.42313 0.925287 6.4425 1.92341 8.2225 2.80404C9.9375 3.65279 11.4244 4.38654 13.1725 2.87404C13.2448 2.8114 13.3335 2.7708 13.4281 2.75704C13.5227 2.74329 13.6193 2.75696 13.7064 2.79643C13.7935 2.8359 13.8674 2.89951 13.9195 2.97973C13.9715 3.05995 13.9995 3.15342 14 3.24904Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseFlag);
export default __webpack_public_path__ + "static/media/CourseFlag.fa8326fd44db99f10483126ef250d049.svg";
export { ForwardRef as ReactComponent };